<div class="pdf-page app-aul-035-24" id="aul03524">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> SOLAR PANEL SYSTEMS </b>
  </p>
  <p class="font-large" style="text-align: center">
    <b> PROPERTY NOT COVERED </b>
  </p>
  <br />
  <p class="font-medium">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>

  <p class="font-small">
    This endorsement modifies insurance provided under the following forms.
    <br />
    BUILDING AND PERSONAL PROPERTY COVERAGE FORM <br />
    CONDOMINIUM ASSOCIATION COVERAGE FORM <br />
  </p>
  <br />
  <p class="font-small">
    The following property is added to <b>A. Coverage</b>, paragraph
    <b>2. Property Not Covered</b>
  </p>
  <p class="font-small">
    Covered Property does not include Solar Panel Systems. This includes all and
    any related solar panel arrays, solar panels, photovoltaic cells, batteries,
    related equipment, installation fixings, racking, mounting, wiring,
    controllers, inverters and trackers.
  </p>
  <br />
  <br />
  <br />
  <p class="font-small">
    <b>All other terms and conditions of this policy remain unchanged.</b>
  </p>
</div>
